import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Input } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import FontCustom from '../../../components/Content/FontCustom';
import AppContact from './AppContact';
import UserNewsletterSubscribe from '../../User/components/form/UserNewsletterSubscribe';

function PreFooter(props) {
    return (
        <Row noGutters className="text-black-50">
            <Col xs="12" md="6" className="px-1 py-4 p-lg-5 bg-quaternary">
                <div className="mx-auto mr-md-0 ml-md-auto" style={{ maxWidth: '450px' }}>
                    <AppContact fullWidth />
                </div>
            </Col>
            <Col xs="12" md="6" className="px-1 py-4 p-lg-5 bg-secondary">
                <div className="mx-auto ml-md-0 mr-md-auto" style={{ maxWidth: '450px' }}>
                    <Row>
                        <Col xs="3" sm="2" className="text-center">
                            <FontCustom name="email" size="4.5" />
                        </Col>
                        <Col>
                            <span className="h1"><FormattedMessage id="newsletterTitle" defaultMessage="Newsletter" /></span>
                            <p className="text-primary">
                                <FormattedMessage id="newsletterInfoText" defaultMessage="Want to know more ? Subscribe to our newsletter" />
                            </p>
                        </Col>
                    </Row>
                    <div className=" px-2">
                        <UserNewsletterSubscribe />
                    </div>
                </div>
            </Col>
        </Row>
    );
}


PreFooter.propTypes = {
};

export default PreFooter;
